import { render, staticRenderFns } from "./Self_assessment.vue?vue&type=template&id=6f69d4c7&"
import script from "./Self_assessment.vue?vue&type=script&lang=js&"
export * from "./Self_assessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports